import { useTranslation } from "react-i18next";
import { processTerm } from "../../../api/content/processTerms";
import { termLabel } from "../../../api/content/processTermWords";
import type { AttachedForm } from "../../../api/content/searchApi";
import Chip from "../../../ui/feedback/Chip";
import { iriLocalName } from "../../../shared/references/shortReferences";

const ACCEPTED = processTerm("Accepted");

/**
 * A document's most developed form (F88, v1's raw, annotated and ontology regests): its
 * data class of the highest stage, named by the DMW process ontology, in its state. Accepted
 * data shows as a success chip; proposed data as a plain one with its state beside. Hover
 * lists every kind. A raw document shows nothing.
 */
export default function AttachedStatus({ forms }: { forms: readonly AttachedForm[] }) {
  const { t } = useTranslation();
  const [mostDeveloped] = forms;
  if (mostDeveloped === undefined) return null;
  const name = (iri: string) => termLabel(iri, t) ?? iriLocalName(iri);
  const accepted = mostDeveloped.state === ACCEPTED;
  return (
    <Chip
      size="compact"
      tone={accepted ? "success" : "neutral"}
      // Whole, never cut off (F137): where it doesn't fit beside the key, its row puts it beneath.
      className="shrink-0"
      title={forms.map((form) => `${name(form.kind)}: ${name(form.state)}`).join("\n")}
    >
      {accepted ? name(mostDeveloped.kind) : t("search.attached.inState", { kind: name(mostDeveloped.kind), state: name(mostDeveloped.state) })}
    </Chip>
  );
}
